import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Result } from 'antd';

const PageNotFound: React.FC = () => {
    const navigate = useNavigate();

    const handleClick = () => {
        navigate('/');
    };

    return (
        <Result
            status="404"
            title="404 Not Found"
            subTitle="Sorry, the page you visited does not exist."
            extra={
                <Button shape="round" onClick={handleClick} type="primary">
                    Back Home
                </Button>
            }
        />
    );
};

export default PageNotFound;
